export default function LoadingScreen() {
  return (
    <div className='d-flex justify-content-center p-5'>
      <div className='spinner-border text-primary' />
    </div>
  );
}
